import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

import { API } from "@/lib/api";

const MagicVerify = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setSessionUser } = useAuth();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token") || "";
    axios
      .post(`${API}/auth/magic/verify`, { token }, { withCredentials: true })
      .then((r) => {
        setSessionUser(r.data);
        navigate(["admin", "member"].includes(r.data.role) ? "/admin" : "/", { replace: true });
      })
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, [params, navigate, setSessionUser]);

  return (
    <section className="flex min-h-screen items-center justify-center bg-mist px-5 pt-28">
      <div className="rounded-3xl border border-gray-100 bg-white p-10 text-center shadow-xl shadow-navy/5">
        {error ? (
          <>
            <ShieldAlert className="mx-auto h-10 w-10 text-gold" />
            <h1 className="mt-5 font-heading text-xl font-bold text-ink">{error}</h1>
            <Link
              to="/login"
              className="mt-6 inline-block rounded-full bg-navy px-8 py-3 font-heading text-xs font-bold uppercase tracking-widest text-white"
            >
              Request a New Link
            </Link>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto h-8 w-8 animate-spin text-navy" />
            <p className="mt-4 text-sm text-fog">Signing you in securely…</p>
          </>
        )}
      </div>
    </section>
  );
};

export default MagicVerify;
